import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useDocumentTitle = (title: string) => {
    const { pathname } = useLocation();
    useEffect(() => {
        try {
            document.title = `MyAdvocate | ${title}`;
        } catch (error) {
            document.title = `MyAdvocate`;
        }
        return () => {
            document.title = `MyAdvocate`;
        };
    }, [pathname]);
};

export default useDocumentTitle;
